import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 네트워크 장비 기준으로 현재 지원하는 제조사 목록을 조회한다.
   * @author Ju
   * @return {array} 제조사 목록
   */
  getProvidedCompanyList() {
    return axios.get(`${baseUrl}/common/netdevice/get-provided-company-list.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/common/netdevice.js